import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Search, Download } from "lucide-react";
import { api, API } from "../../api";
import { APageHead, ATable, ABadge, APager } from "../adminKit";

export default function AdminUsers() {
  const nav = useNavigate();
  const [data, setData] = useState({ items: [], pages: 1, total: 0 });
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState("");
  const [role, setRole] = useState("");
  const [status, setStatus] = useState("");
  const [plan, setPlan] = useState("");
  const [page, setPage] = useState(1);

  const load = useCallback(() => {
    setLoading(true);
    api.get("/admin/users", { params: { q, role, status, plan, page, limit: 15 } })
      .then(({ data }) => setData(data)).finally(() => setLoading(false));
  }, [q, role, status, plan, page]);
  useEffect(() => { load(); }, [load]);

  const exportCsv = () => {
    const token = localStorage.getItem("cc_token");
    fetch(`${API}/admin/exports/users`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => r.blob()).then((b) => { const u = URL.createObjectURL(b); const a = document.createElement("a"); a.href = u; a.download = "users.csv"; a.click(); URL.revokeObjectURL(u); });
  };

  const columns = [
    { key: "name", label: "Name", render: (r) => <span className="text-white">{r.name || "—"}</span> },
    { key: "email", label: "Email" },
    { key: "role", label: "Role", render: (r) => <ABadge tone={r.role === "super_admin" ? "purple" : r.role === "user" ? "default" : "blue"}>{r.role.replace("_", " ")}</ABadge> },
    { key: "status", label: "Status", render: (r) => <ABadge tone={r.status}>{r.status}</ABadge> },
    { key: "plan", label: "Plan", render: (r) => <ABadge tone={r.plan === "free" ? "default" : "green"}>{r.plan}</ABadge> },
    { key: "created_at", label: "Signup", render: (r) => r.created_at ? new Date(r.created_at).toLocaleDateString() : "—" },
    { key: "last_login", label: "Last Login", render: (r) => r.last_login ? new Date(r.last_login).toLocaleDateString() : "—" },
  ];

  const sel = "cc-input rounded-lg px-3 py-2 text-sm";
  return (
    <div className="space-y-4">
      <APageHead title="User Management" subtitle={`${data.total} registered users`}
        action={<button onClick={exportCsv} data-testid="export-users" className="inline-flex items-center gap-2 rounded-xl border border-white/12 px-4 py-2.5 text-sm text-white cc-nav-item"><Download size={15} /> Export CSV</button>} />

      <div className="cc-card rounded-xl p-4 flex flex-wrap gap-3 items-center">
        <div className="relative flex-1 min-w-[220px]">
          <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" />
          <input value={q} onChange={(e) => { setPage(1); setQ(e.target.value); }} placeholder="Search name, email, or ID…" className="cc-input w-full rounded-lg pl-9 pr-3 py-2 text-sm" data-testid="user-search" />
        </div>
        <select value={role} onChange={(e) => { setPage(1); setRole(e.target.value); }} className={sel} data-testid="filter-role">
          <option value="" className="bg-[#1a1a24]">All roles</option>
          {["user", "support", "moderator", "admin", "super_admin"].map((r) => <option key={r} className="bg-[#1a1a24]">{r}</option>)}
        </select>
        <select value={status} onChange={(e) => { setPage(1); setStatus(e.target.value); }} className={sel} data-testid="filter-status">
          <option value="" className="bg-[#1a1a24]">All statuses</option>
          {["active", "suspended", "deleted"].map((r) => <option key={r} className="bg-[#1a1a24]">{r}</option>)}
        </select>
        <select value={plan} onChange={(e) => { setPage(1); setPlan(e.target.value); }} className={sel} data-testid="filter-plan">
          <option value="" className="bg-[#1a1a24]">All plans</option>
          {["free", "pro", "business", "enterprise"].map((r) => <option key={r} className="bg-[#1a1a24]">{r}</option>)}
        </select>
      </div>

      <ATable columns={columns} rows={data.items} loading={loading} onRow={(r) => nav(`/admin/users/${r.id}`)} />
      <APager page={page} pages={data.pages} onPage={setPage} />
    </div>
  );
}
